// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file codes/v3/destination.proto (package codes.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file codes/v3/destination.proto.
 */
export const file_codes_v3_destination: GenFile =
	/*@__PURE__*/
	fileDesc(
		"Chpjb2Rlcy92My9kZXN0aW5hdGlvbi5wcm90bxIIY29kZXMudjMiIgoSR1MxRGlnaXRhbExpbmtEYXRhEgwKBGd0aW4YASABKAkq6QYKD0Rlc3RpbmF0aW9uVHlwZRIgChxERVNUSU5BVElPTl9UWVBFX1VOU1BFQ0lGSUVEEAASGAoUREVTVElOQVRJT05fVFlQRV9VUkwQARIYChRERVNUSU5BVElPTl9UWVBFX1NNUxACEhoKFkRFU1RJTkFUSU9OX1RZUEVfRVZFTlQQAxIZChVERVNUSU5BVElPTl9UWVBFX0ZJTEUQBBIaChZERVNUSU5BVElPTl9UWVBFX1ZFTk1PEAUSHgoaREVTVElOQVRJT05fVFlQRV9JTlNUQUdSQU0QBhIdChlERVNUSU5BVElPTl9UWVBFX0ZBQ0VCT09LEAcSHQoZREVTVElOQVRJT05fVFlQRV9MSU5LRURJThAIEhsKF0RFU1RJTkFUSU9OX1RZUEVfVElLVE9LEAkSHQoZREVTVElOQVRJT05fVFlQRV9TTkFQQ0hBVBAKEhwKGERFU1RJTkFUSU9OX1RZUEVfVFdJVFRFUhALEhwKGERFU1RJTkFUSU9OX1RZUEVfU1BPVElGWRAMEh8KG0RFU1RJTkFUSU9OX1RZUEVfR09PR0xFX0RPQxANEhwKGERFU1RJTkFUSU9OX1RZUEVfWU9VVFVCRRAOEhsKF0RFU1RJTkFUSU9OX1RZUEVfU09DSUFMEA8SGgoWREVTVElOQVRJT05fVFlQRV9QSE9ORRAQEh0KGURFU1RJTkFUSU9OX1RZUEVfRkxPV1BBR0UQERIZChVERVNUSU5BVElPTl9UWVBFX1dJRkkQEhIhCh1ERVNUSU5BVElPTl9UWVBFX1NPQ0lBTF9NRURJQRATEiAKHERFU1RJTkFUSU9OX1RZUEVfU0NBTl9UT19PV04QFBIlCiFERVNUSU5BVElPTl9UWVBFX1NDQU5fVE9fQUNUSVZBVEUQFRIeChpERVNUSU5BVElPTl9UWVBFX1BSRVNFVF9GUBAWEiMKH0RFU1RJTkFUSU9OX1RZUEVfQ09MTEVDVElCTEVfRlAQFxIhCh1ERVNUSU5BVElPTl9UWVBFX09ORV9USU1FX1VSTBAYEhoKFkRFU1RJTkFUSU9OX1RZUEVfVkNBUkQQGRIZChVERVNUSU5BVElPTl9UWVBFX1JVTEUQGhIaChZERVNUSU5BVElPTl9UWVBFX0VNQUlMEBtiBnByb3RvMw",
	);

/**
 * GS1DigitalLinkData contains structured data for GS1 Digital Link codes.
 *
 * @generated from message codes.v3.GS1DigitalLinkData
 */
export type GS1DigitalLinkData = Message<"codes.v3.GS1DigitalLinkData"> & {
	/**
	 * @generated from field: string gtin = 1;
	 */
	gtin: string;
};

/**
 * GS1DigitalLinkData contains structured data for GS1 Digital Link codes.
 *
 * @generated from message codes.v3.GS1DigitalLinkData
 */
export type GS1DigitalLinkDataJson = {
	/**
	 * @generated from field: string gtin = 1;
	 */
	gtin?: string;
};

/**
 * Describes the message codes.v3.GS1DigitalLinkData.
 * Use `create(GS1DigitalLinkDataSchema)` to create a new message.
 */
export const GS1DigitalLinkDataSchema: GenMessage<GS1DigitalLinkData, { jsonType: GS1DigitalLinkDataJson }> = /*@__PURE__*/ messageDesc(file_codes_v3_destination, 0);

/**
 * @generated from enum codes.v3.DestinationType
 */
export enum DestinationType {
	/**
	 * @generated from enum value: DESTINATION_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: DESTINATION_TYPE_URL = 1;
	 */
	URL = 1,

	/**
	 * @generated from enum value: DESTINATION_TYPE_SMS = 2;
	 */
	SMS = 2,

	/**
	 * @generated from enum value: DESTINATION_TYPE_EVENT = 3;
	 */
	EVENT = 3,

	/**
	 * @generated from enum value: DESTINATION_TYPE_FILE = 4;
	 */
	FILE = 4,

	/**
	 * @generated from enum value: DESTINATION_TYPE_VENMO = 5;
	 */
	VENMO = 5,

	/**
	 * @generated from enum value: DESTINATION_TYPE_INSTAGRAM = 6;
	 */
	INSTAGRAM = 6,

	/**
	 * @generated from enum value: DESTINATION_TYPE_FACEBOOK = 7;
	 */
	FACEBOOK = 7,

	/**
	 * @generated from enum value: DESTINATION_TYPE_LINKEDIN = 8;
	 */
	LINKEDIN = 8,

	/**
	 * @generated from enum value: DESTINATION_TYPE_TIKTOK = 9;
	 */
	TIKTOK = 9,

	/**
	 * @generated from enum value: DESTINATION_TYPE_SNAPCHAT = 10;
	 */
	SNAPCHAT = 10,

	/**
	 * @generated from enum value: DESTINATION_TYPE_TWITTER = 11;
	 */
	TWITTER = 11,

	/**
	 * @generated from enum value: DESTINATION_TYPE_SPOTIFY = 12;
	 */
	SPOTIFY = 12,

	/**
	 * @generated from enum value: DESTINATION_TYPE_GOOGLE_DOC = 13;
	 */
	GOOGLE_DOC = 13,

	/**
	 * @generated from enum value: DESTINATION_TYPE_YOUTUBE = 14;
	 */
	YOUTUBE = 14,

	/**
	 * @generated from enum value: DESTINATION_TYPE_SOCIAL = 15;
	 */
	SOCIAL = 15,

	/**
	 * @generated from enum value: DESTINATION_TYPE_PHONE = 16;
	 */
	PHONE = 16,

	/**
	 * @generated from enum value: DESTINATION_TYPE_FLOWPAGE = 17;
	 */
	FLOWPAGE = 17,

	/**
	 * @generated from enum value: DESTINATION_TYPE_WIFI = 18;
	 */
	WIFI = 18,

	/**
	 * @generated from enum value: DESTINATION_TYPE_SOCIAL_MEDIA = 19;
	 */
	SOCIAL_MEDIA = 19,

	/**
	 * @generated from enum value: DESTINATION_TYPE_SCAN_TO_OWN = 20;
	 */
	SCAN_TO_OWN = 20,

	/**
	 * @generated from enum value: DESTINATION_TYPE_SCAN_TO_ACTIVATE = 21;
	 */
	SCAN_TO_ACTIVATE = 21,

	/**
	 * @generated from enum value: DESTINATION_TYPE_PRESET_FP = 22;
	 */
	PRESET_FP = 22,

	/**
	 * @generated from enum value: DESTINATION_TYPE_COLLECTIBLE_FP = 23;
	 */
	COLLECTIBLE_FP = 23,

	/**
	 * @generated from enum value: DESTINATION_TYPE_ONE_TIME_URL = 24;
	 */
	ONE_TIME_URL = 24,

	/**
	 * @generated from enum value: DESTINATION_TYPE_VCARD = 25;
	 */
	VCARD = 25,

	/**
	 * @generated from enum value: DESTINATION_TYPE_RULE = 26;
	 */
	RULE = 26,

	/**
	 * @generated from enum value: DESTINATION_TYPE_EMAIL = 27;
	 */
	EMAIL = 27,
}

/**
 * @generated from enum codes.v3.DestinationType
 */
export type DestinationTypeJson =
	| "DESTINATION_TYPE_UNSPECIFIED"
	| "DESTINATION_TYPE_URL"
	| "DESTINATION_TYPE_SMS"
	| "DESTINATION_TYPE_EVENT"
	| "DESTINATION_TYPE_FILE"
	| "DESTINATION_TYPE_VENMO"
	| "DESTINATION_TYPE_INSTAGRAM"
	| "DESTINATION_TYPE_FACEBOOK"
	| "DESTINATION_TYPE_LINKEDIN"
	| "DESTINATION_TYPE_TIKTOK"
	| "DESTINATION_TYPE_SNAPCHAT"
	| "DESTINATION_TYPE_TWITTER"
	| "DESTINATION_TYPE_SPOTIFY"
	| "DESTINATION_TYPE_GOOGLE_DOC"
	| "DESTINATION_TYPE_YOUTUBE"
	| "DESTINATION_TYPE_SOCIAL"
	| "DESTINATION_TYPE_PHONE"
	| "DESTINATION_TYPE_FLOWPAGE"
	| "DESTINATION_TYPE_WIFI"
	| "DESTINATION_TYPE_SOCIAL_MEDIA"
	| "DESTINATION_TYPE_SCAN_TO_OWN"
	| "DESTINATION_TYPE_SCAN_TO_ACTIVATE"
	| "DESTINATION_TYPE_PRESET_FP"
	| "DESTINATION_TYPE_COLLECTIBLE_FP"
	| "DESTINATION_TYPE_ONE_TIME_URL"
	| "DESTINATION_TYPE_VCARD"
	| "DESTINATION_TYPE_RULE"
	| "DESTINATION_TYPE_EMAIL";

/**
 * Describes the enum codes.v3.DestinationType.
 */
export const DestinationTypeSchema: GenEnum<DestinationType, DestinationTypeJson> = /*@__PURE__*/ enumDesc(file_codes_v3_destination, 0);
